/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Allcoinvestments3Inputs */

const en_coinvestments_allcoinvestments3 = /** @type {(inputs: Coinvestments_Allcoinvestments3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All Co-investments`)
};

/**
* | output |
* | --- |
* | "All Co-investments" |
*
* @param {Coinvestments_Allcoinvestments3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_allcoinvestments3 = /** @type {((inputs?: Coinvestments_Allcoinvestments3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Allcoinvestments3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_allcoinvestments3(inputs)
});
export { coinvestments_allcoinvestments3 as "coInvestments_allCoInvestments" }